module.exports = __webpack_public_path__ + "static/img/pico30.6835d99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pico30.png
// module id = KRdd
// module chunks = 0